import { graphql } from 'app/generated/gql'

export const DNI_MANAGED_NUMBERS_QUERY = graphql(`
  query DniManagedNumbers($search: String, $pagination: PaginationInput) {
    phoneNumbers(search: $search, pagination: $pagination) {
      hits {
        id
        phone
        label
        roles
      }
    }
  }
`)

export const DNI_FOR_MODAL_QUERY = graphql(`
  query DniForModal($id: ID!) {
    dni(id: $id) {
      id
      label
      forwardTo
      areaCode
      poolSize
      sessionDuration
      maxPoolSize
      minFree
      buyStep
      minPoolSize
      ivrConfigId
    }
  }
`)
